import React from "react";
import parseWithIcons from "../../utils/parseWithIcons";

const ContenuDynamiqueTexteImage = ({ data }) => {
  let blocLeft, blocRight;

  let renderImage = (dir) => {
    return (
      <div className={`image ${dir} ${data.imageFormat}`}>
        {data.image && (
          <figure>
            <picture>
              <source
                type="image/webp"
                srcSet={data.image.localFile.childImageSharp.fluid.srcWebp}
                data-srcset={
                  data.image.localFile.childImageSharp.fluid.srcSetWebp
                }
              />
              <source
                type="image/jpeg"
                srcSet={data.image.localFile.childImageSharp.fluid.src}
              />
              <img
                src={data.image.localFile.childImageSharp.fluid.src}
                alt={data.image.altText}
              />
            </picture>
            <figcaption className="desc">{data.image.altText}</figcaption>
          </figure>
        )}
      </div>
    );
  };

  let renderText = (dir) => {
    return <div className={`text ${dir}`}>{parseWithIcons(data.texte)}</div>;
  };

  if (data.placementDeLimage === "droite") {
    blocLeft = renderText("left");
    blocRight = renderImage("right");
  } else {
    blocLeft = renderImage("left");
    blocRight = renderText("right");
  }

  return (
    <div className="dynamic texte-image">
      <div className="inner">
        <div className="bloc-left">{blocLeft}</div>
        <div className="bloc-right">{blocRight}</div>
      </div>
    </div>
  );
};

export default ContenuDynamiqueTexteImage;
